module.exports = "/_next/static/images/hci_under_ojk_centered_white-92510223e13947905442ec5eb2489376.png";